<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.prenatalConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="singleTypeOfConsultation-group"
                                        :label="$tc('message.typeOfConsultation', 1)"
                                        label-for="singleTypeOfConsultation"
                                >
                                    <select id="singleTypeOfConsultation" v-model="$v.form.typeOfConsultation.$model"
                                            @change="clearErrorField('type_de_consultation')"
                                            required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mTypeOfConsultation" :key="item.id" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.typeOfConsultation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('type_de_consultation')" style="color:red">
                                    {{getErrorsField('type_de_consultation')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="complaints-group"
                                        :label="$tc('message.complaints',2)"
                                        label-for="complaints"
                                >
                                    <b-form-textarea
                                            id="complaints"
                                            v-model="$v.form.complaints.$model"
                                            :state="$v.form.complaints.$dirty ? !$v.form.complaints.$error : null"
                                            placeholder=""
                                            @keydown="clearErrorField('plaintes')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('plaintes')" style="color:red">
                                    {{getErrorsField('plaintes')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="recommendations-group"
                                        :label="$tc('message.recommendations',2)"
                                        label-for="recommendations"
                                >
                                    <b-form-textarea
                                            id="recommendations"
                                            v-model="$v.form.recommendations.$model"
                                            :state="$v.form.recommendations.$dirty ? !$v.form.recommendations.$error : null"
                                            placeholder=""
                                            @keydown="clearErrorField('recommandations')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('recommandations')" style="color:red">
                                    {{getErrorsField('recommandations')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="clinique-group"
                                        :label="$tc('message.physicalExams', 2)"
                                        label-for="clinique"
                                >
                                    <b-form-textarea
                                            id="clinique"
                                            v-model="$v.form.examen_clinique.$model"
                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_clinique')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
                                        {{ getErrorsField('examen_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="complementaire-group"
                                        :label="$tc('message.complementaryExams', 2)"
                                        label-for="complementaire"
                                >
                                    <b-form-textarea
                                            id="complementaire"
                                            v-model="$v.form.examen_complementaire.$model"
                                            :state="$v.form.examen_complementaire.$dirty ? !(errorshasField('examen_complementaire') || $v.form.examen_complementaire.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_complementaire')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_complementaire')">
                                        {{ getErrorsField('examen_complementaire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-center">
                            <b-button @click="onSubmit" variant="primary" v-if="can">
                                {{ $t('message.save') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import SlimSelect from 'slim-select';
    import $ from "jquery";

    export default {
        name: "AddPrenatal",
        computed: {
            ...mapGetters(["obstetricConsultation",
                'errors',
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            nomEtDossier:function(){
                let consultation = this.obstetricConsultation;
                if(typeof consultation.user =='object'){
                    let user = consultation.user;
                    let prenom = (user.prenom != null ? user.prenom : '');
                    prenom =  prenom.toLowerCase();
                    let nom =  ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    let dossier = consultation.dossier;
                    return   nom+ ' ( ' + dossier.numero_dossier+' ) : ' +consultation.numero_grossesse;
                }
                return "";
            },

            rows: function() {
                return this.mConsultations.length;
            },

            mTypeOfConsultation: function() {
                let sArray = [
                    {text:'1 CPN' ,value:'1 CPN',id:0},
                    {text:'2 CPN' ,value:'2 CPN',id:1},
                    {text:'3 CPN' ,value:'3 CPN',id:2},
                    {text:'4 CPN' ,value:'4 CPN',id:3},
                    {text:'5 CPN' ,value:'5 CPN',id:4},
                    {text:'6 CPN' ,value:'6 CPN',id:5},
                    {text:'7 CPN' ,value:'7 CPN',id:6},
                    {text:'8 CPN' ,value:'8 CPN',id:7},
                    {text:'9 CPN' ,value:'9 CPN',id:8},
                    {text:'10 CPN' ,value:'10 CPN',id:9},
                    {text:'11 CPN' ,value:'11 CPN',id:10},
                    {text:'12 CPN' ,value:'12 CPN',id:11},
                ];
                return sArray;
            }
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    typeOfConsultation:'',
                    complaints: '',
                    antecedentSpouse: '',
                    recommendations: '',
                    examen_clinique: '',
                    examen_complementaire: '',
                },
                show: true
            }
        },
        methods: {

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch('getObstetricConsultation', { args : args });

            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_obstetrique_id:this.obstetricConsultation.id,
                        type_de_consultation: this.form.typeOfConsultation,
                        plaintes: this.form.complaints,
                        recommandations: this.form.recommendations,
                        examen_clinique: this.form.examen_clinique,
                        examen_complementaire: this.form.examen_complementaire,
                    };

                    let successMessage = this.$i18n.t('message.prenatalConsultationCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createPrenatalConsultation', { args, errorMessages, successMessage });
                }else{
                    $('html, body').animate({scrollTop:0}, '300');
                }
            },

            onReset: function(evt) {
                // evt.preventDefault();
                //
                // // Reset our form values
                // this.from.consultation_obstetrique_id='';
                // this.from.typeOfConsultation= '';
                // this.from.complaints= '';
                // this.from.antecedentSpouse= '';
                // this.from.recommendations= '';
                // this.form.examen_clinique = '';
                // this.form.examen_complementaire = '';
                //
                // // Trick to reset/clear native browser form validation state
                // this.show = false;
                //
                // this.$nextTick(() => {
                //     this.show = true;
                // });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },
        validations: {
            form: {

                typeOfConsultation:{
                    required
                },
                complaints: {
                    //
                },

                recommendations: {
                    //
                },
                examen_clinique: {
                    //
                },

                examen_complementaire: {
                    //
                },
            }
        },
        mounted() {
            // Fetch obstetric consultation list
            this.getConsultation();
            new SlimSelect({
                select: '#singleTypeOfConsultation',
                placeholder: 'Select consultation type',

            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>